import React, {
	forwardRef,
	useEffect,
	useImperativeHandle,
	useRef,
	useState,
} from "react";
import styled from "styled-components";

const StyledWrapper = styled.div`
	.checkbox-wrapper-46 input[type="checkbox"] {
		display: none;
		visibility: hidden;
	}

	.checkbox-wrapper-46 .cbx {
		margin: auto;
		-webkit-user-select: none;
		user-select: none;
		cursor: pointer;
	}

	.checkbox-wrapper-46 .cbx span {
		display: inline-block;
		vertical-align: middle;
		transform: translate3d(0, 0, 0);
	}

	.checkbox-wrapper-46 .cbx span:first-child {
		position: relative;
		width: 18px;
		height: 18px;
		border-radius: 3px;
		transform: scale(1);
		vertical-align: middle;
		border: 2px solid
			var(
				${(props) =>
					props.hasError
						? "--color-error"
						: "--color-surface-variant"}
			);
		transition: all 0.2s ease;
	}

	.checkbox-wrapper-46 .cbx span:first-child svg {
		position: absolute;
		top: 2px;
		left: 1px;
		fill: none;
		stroke: var(
			${(props) =>
				props.hasError ? "--color-on-error" : "--color-on-primary"}
		);
		stroke-width: 2;
		stroke-linecap: round;
		stroke-linejoin: round;
		stroke-dasharray: 16px;
		stroke-dashoffset: 16px;
		transition: all 0.3s ease;
		transition-delay: 0.1s;
		transform: translate3d(0, 0, 0);
	}

	.checkbox-wrapper-46 .cbx span:first-child:before {
		content: "";
		width: 100%;
		height: 100%;
		background: var(
			${(props) => (props.hasError ? "--color-error" : "--color-primary")}
		);
		display: block;
		transform: scale(0);
		opacity: 1;
		border-radius: 50%;
	}

	.checkbox-wrapper-46 .cbx span:last-child {
		padding-left: 8px;
	}

	.checkbox-wrapper-46 .cbx:hover span:first-child {
		border-color: var(
			${(props) => (props.hasError ? "--color-error" : "--color-primary")}
		);
	}

	.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child {
		background: var(
			${(props) => (props.hasError ? "--color-error" : "--color-primary")}
		);
		border-color: var(
			${(props) => (props.hasError ? "--color-error" : "--color-primary")}
		);
		animation: wave-46 0.4s ease;
	}

	.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child svg {
		stroke-dashoffset: 0;
	}

	.checkbox-wrapper-46 .inp-cbx:checked + .cbx span:first-child:before {
		transform: scale(3.5);
		opacity: 0;
		transition: all 0.6s ease;
	}

	@keyframes wave-46 {
		50% {
			transform: scale(0.9);
		}
	}
`;

const Checkbox = forwardRef(({ id, label, isChecked, onChange = () => {} }, ref) => {
	const [checkboxLabel, setCheckboxLabel] = useState(label);
	const [hasError, setHasError] = useState(false);

	const checkboxRef = useRef(null);

	useEffect(() => {
		setCheckboxLabel(label);
	}, [label]);

	const handleOnCheckChange = (e) => {
        setHasError(false);
        onChange(checkboxRef.current.value);
	};

	useImperativeHandle(ref, () => {
		return {
			getValue: () => checkboxRef.current.value,
			setError: (error = true) => {
				setHasError(error);
			},
		};
	});

	return (
		<StyledWrapper hasError={hasError}>
			<div className="checkbox-wrapper-46">
				<input
					ref={checkboxRef}
					defaultChecked={isChecked}
					type="checkbox"
                    id={`checkbox-${id}`}
                    name={id}
					className="inp-cbx"
					onChange={handleOnCheckChange}
				/>
				<label htmlFor={`checkbox-${id}`} className="cbx">
					<span>
						<svg viewBox="0 0 12 10" height="10px" width="12px">
							<polyline points="1.5 6 4.5 9 10.5 1" />
						</svg>
					</span>
					<span>{checkboxLabel}</span>
				</label>
			</div>
		</StyledWrapper>
	);
});

export default Checkbox;
